
import { useEffect, useState } from "react";
import Dropzone from "react-dropzone"
import { Link } from "react-router-dom"
import { Alert, Card, Col, Form, Row } from "reactstrap"
import { useFormik } from "formik";
import { useDocumentCreateMutation } from "store";

const DocumentsUpload = (props: any) => {

  const [selectedFiles, setSelectedFiles] = useState<any>([]);
  const [documentCreate, documentCreateResult] = useDocumentCreateMutation();


  useEffect(() => {
  }, [props]);

  function handleAcceptedFiles(files: any) {
    const updatedFiles = files.map((file: any) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    setSelectedFiles(updatedFiles);
  }

  function formatBytes(bytes: any, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  const handleRemoveFile = (index: number) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  
  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {},
    onSubmit: (values: any) => {
  
      const formData = new FormData();

      formData.append('table_name', props?.table_name);
      formData.append('connection_id', props?.connection_id);
      formData.append('value_group', props?.value_group);

      if (selectedFiles && selectedFiles.length > 0) {
        selectedFiles.forEach((file: File, index: number) => {
          formData.append(`files`, file);
        });
      }
      documentCreate(formData)
      setSelectedFiles([]);
    },
  });

  return (
    <>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}
      >
        <Col lg={12}>
          <div className="mb-3">
            <Dropzone
              onDrop={(acceptedFiles: any) => {
                handleAcceptedFiles(acceptedFiles)
              }}
              accept={{
                'application/octet-stream': ['.jpeg', '.png', '.jpg', '.pdf', '.doc', '.docx']
              }}
            >
              {({ getRootProps, getInputProps }: any) => (
                <div className="dropzone">
                  <div
                    className="dz-message needsclick mt-2"
                    {...getRootProps()}
                  >
                    <input {...getInputProps()} />
                    <div className="mb-3">
                      <i className="display-4 text-muted mdi mdi-cloud-upload-outline" />
                    </div>
                    <Alert color="info" className="mb-0 fs-5">
                      <i className="mdi mdi-alert-circle-outline me-2"></i>
                      Таны оруулж буй файлын өргөтгөл нь  {" "}
                      <Link to="#" className="alert-link">
                        .jpeg .png .jpg .pdf .doc .docx
                      </Link>  {" "}
                      байх ёстой анхаарна уу !
                    </Alert>
                  </div>
                </div>
              )}
            </Dropzone>
            <div className="dropzone-previews mt-3" id="file-previews">
              {selectedFiles?.map((f: any, i: any) => {
                return (
                  <Card
                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                    key={i + "-file"}
                  >
                    <div className="p-2">
                      <Row className="align-items-center">
                        <Col className="col-auto">
                          <img
                            data-dz-thumbnail=""
                            height="80"
                            className="avatar-sm rounded bg-light"
                            alt={f.name}
                            src={f.preview}
                          />
                        </Col>
                        <Col>
                          <Link
                            to="#"
                            className="text-muted font-weight-bold"
                          >
                            {f.name}
                          </Link>
                          <p className="mb-0">
                            <strong>{f.formattedSize}</strong>
                          </p>
                        </Col>
                        <Col className="col-auto">
                          <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => handleRemoveFile(i)}
                          >
                            Устгах
                          </button>
                        </Col>
                      </Row>
                    </div>
                  </Card>
                )
              })}
            </div>
          </div>
        </Col>
        <Col lg={12} className="d-flex justify-content-center mt-3">
          <button type="submit" className="btn btn-primary"> Хадгалах </button>
        </Col>
      </Form>

    </>
  )
}

export default DocumentsUpload;